<script>
  import { getInitialValue } from './utils';
  import Editor from './Editor.svelte';
  import Preview from './Preview.svelte';
  
  export let markdownValue = getInitialValue();

</script>

<main class="markdown-app">
  <header><span>Edi-t Don't!</span><img src="images/edi-dont.jpg" alt="de wag"></header>
  <!-- <button on:click={handleSave}>Save yourself</button> -->
  <div class="markdown-app__container">
    <Editor bind:markdownValue={markdownValue} />
    <Preview {markdownValue} />
  </div>
</main>

<style>
  header {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
    font-weight: 500;
    margin: 20px 0 30px;
    color: #ffd700;
    text-transform: uppercase;
  }
  
  img {
    height: 60px;
    margin-left: 10px;
  }

  .markdown-app {
    height: 100vh;
  }

	.markdown-app__container {
		display: grid;
    grid-template-columns: repeat(2, 1fr);
    height: 85%;
    width: 100%;
	}


	@media (min-width: 640px) {
		.markdown-app {
			max-width: none;
		}
	}
</style>